module.exports = __webpack_public_path__ + "brankic.009115cbfbd6a9d386f3.svg";


//////////////////
// WEBPACK FOOTER
// ./fonts/brankic.svg
// module id = 206
// module chunks = 2